const Paragraph = ({
  color = '#E9BF6E',
  width = 24,
  height = 25,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 3.82031H4C3.44772 3.82031 3 4.26803 3 4.82031V8.82031C3 9.3726 3.44772 9.82031 4 9.82031H8C8.55228 9.82031 9 9.3726 9 8.82031V4.82031C9 4.26803 8.55228 3.82031 8 3.82031Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path d="M14 4.82031H21" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M14 8.82031H21" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" />
      <path
        d="M8 15.8203H4C3.44772 15.8203 3 16.268 3 16.8203V20.8203C3 21.3726 3.44772 21.8203 4 21.8203H8C8.55228 21.8203 9 21.3726 9 20.8203V16.8203C9 16.268 8.55228 15.8203 8 15.8203Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path d="M14 16.8203H21" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M14 20.8203H21" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" />
    </svg>
  );
};

export default Paragraph;
